module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.compoment, {
    tag: "component"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97388302","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar/HeaderCampanha.vue
// module id = 750
// module chunks = 7